/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const componentDictionary = {};

componentDictionary['__local__|__local__|modules|btrts-donations-details|components|btrts-donations-add-to-cart-source'] = {
                c: () => require('partner/modules/btrts-donations-details/components/btrts-donations-add-to-cart-source.component.tsx'),
                cn: '__local__-__local__-btrts-donations-add-to-cart-source'
            };
componentDictionary['__local__|__local__|modules|btrts-donations-details|components|btrts-donations-add-to-cart'] = {
                c: () => require('partner/modules/btrts-donations-details/components/btrts-donations-add-to-cart.component.tsx'),
                cn: '__local__-__local__-btrts-donations-add-to-cart'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|component|ecomm-form-add-to-cart-source'] = {
                c: () => require('partner/modules/ecomm-product-details-form/component/ecomm-form-add-to-cart-source.component.tsx'),
                cn: '__local__-__local__-ecomm-form-add-to-cart-source'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|component|ecomm-form-add-to-cart'] = {
                c: () => require('partner/modules/ecomm-product-details-form/component/ecomm-form-add-to-cart.component.tsx'),
                cn: '__local__-__local__-ecomm-form-add-to-cart'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|amountDeceasedNameForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/amountDeceasedNameForm.component.tsx'),
                cn: '__local__-__local__-amountDeceasedNameForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|categoryNamesAddressForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/categoryNamesAddressForm.component.tsx'),
                cn: '__local__-__local__-categoryNamesAddressForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|categoryNamesCollectionForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/categoryNamesCollectionForm.component.tsx'),
                cn: '__local__-__local__-categoryNamesCollectionForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|categoryNamesForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/categoryNamesForm.component.tsx'),
                cn: '__local__-__local__-categoryNamesForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|ceremonyForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/ceremonyForm.component.tsx'),
                cn: '__local__-__local__-ceremonyForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|coursesForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/coursesForm.component.tsx'),
                cn: '__local__-__local__-coursesForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|deceasedCategoryNamesForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/deceasedCategoryNamesForm.component.tsx'),
                cn: '__local__-__local__-deceasedCategoryNamesForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|deceasedDedicatedByForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/deceasedDedicatedByForm.component.tsx'),
                cn: '__local__-__local__-deceasedDedicatedByForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|donationForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/donationForm.component.tsx'),
                cn: '__local__-__local__-donationForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|eventCategoryNamesForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/eventCategoryNamesForm.component.tsx'),
                cn: '__local__-__local__-eventCategoryNamesForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|eventDeceasedDedicatedByForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/eventDeceasedDedicatedByForm.component.tsx'),
                cn: '__local__-__local__-eventDeceasedDedicatedByForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|eventPassportUploadInsuranceForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/eventPassportUploadInsuranceForm.component.tsx'),
                cn: '__local__-__local__-eventPassportUploadInsuranceForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|eventsChineseNameForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/eventsChineseNameForm.component.tsx'),
                cn: '__local__-__local__-eventsChineseNameForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|eventsNextOfKinNameForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/eventsNextOfKinNameForm.component.tsx'),
                cn: '__local__-__local__-eventsNextOfKinNameForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|eventsPassportUploadForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/eventsPassportUploadForm.component.tsx'),
                cn: '__local__-__local__-eventsPassportUploadForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|eventTaxDeductionForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/eventTaxDeductionForm.component.tsx'),
                cn: '__local__-__local__-eventTaxDeductionForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|nameBirthDatetimeForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/nameBirthDatetimeForm.component.tsx'),
                cn: '__local__-__local__-nameBirthDatetimeForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|nameBirthdaySchoolForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/nameBirthdaySchoolForm.component.tsx'),
                cn: '__local__-__local__-nameBirthdaySchoolForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|nameDedicationStartDate'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/nameDedicationStartDate.component.tsx'),
                cn: '__local__-__local__-nameDedicationStartDate'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|namesAddressContactnoForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/namesAddressContactnoForm.component.tsx'),
                cn: '__local__-__local__-namesAddressContactnoForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|namesOnlyForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/namesOnlyForm.component.tsx'),
                cn: '__local__-__local__-namesOnlyForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|namesRemarksForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/namesRemarksForm.component.tsx'),
                cn: '__local__-__local__-namesRemarksForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|noOfYearsCategoryNamesForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/noOfYearsCategoryNamesForm.component.tsx'),
                cn: '__local__-__local__-noOfYearsCategoryNamesForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|offeringForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/offeringForm.component.tsx'),
                cn: '__local__-__local__-offeringForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|servicesBusinessForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/servicesBusinessForm.component.tsx'),
                cn: '__local__-__local__-servicesBusinessForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|servicesDeceasedForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/servicesDeceasedForm.component.tsx'),
                cn: '__local__-__local__-servicesDeceasedForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|servicesEducationForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/servicesEducationForm.component.tsx'),
                cn: '__local__-__local__-servicesEducationForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|servicesGeneralForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/servicesGeneralForm.component.tsx'),
                cn: '__local__-__local__-servicesGeneralForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|servicesHealthSurgeryForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/servicesHealthSurgeryForm.component.tsx'),
                cn: '__local__-__local__-servicesHealthSurgeryForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|servicesInfantSpiritForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/servicesInfantSpiritForm.component.tsx'),
                cn: '__local__-__local__-servicesInfantSpiritForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|servicesMarriageForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/servicesMarriageForm.component.tsx'),
                cn: '__local__-__local__-servicesMarriageForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|threeCategoryNamesConsecrationForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/threeCategoryNamesConsecrationForm.component.tsx'),
                cn: '__local__-__local__-threeCategoryNamesConsecrationForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-details-form|formsComponents|threeCategoryNamesForm'] = {
                c: () => require('partner/modules/ecomm-product-details-form/formsComponents/threeCategoryNamesForm.component.tsx'),
                cn: '__local__-__local__-threeCategoryNamesForm'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-list|component|btrts-add-to-cart-source'] = {
                c: () => require('partner/modules/ecomm-product-list/component/btrts-add-to-cart-source.component.tsx'),
                cn: '__local__-__local__-btrts-add-to-cart-source'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-list|component|btrts-add-to-cart'] = {
                c: () => require('partner/modules/ecomm-product-list/component/btrts-add-to-cart.component.tsx'),
                cn: '__local__-__local__-btrts-add-to-cart'
            };
componentDictionary['__local__|__local__|modules|ecomm-product-list|component|ecomm-product-list'] = {
                c: () => require('partner/modules/ecomm-product-list/component/ecomm-product-list.component.tsx'),
                cn: '__local__-__local__-ecomm-product-list'
            };
componentDictionary['__local__|__local__|modules|eshop-checkout|components|cartlineitem'] = {
                c: () => require('partner/modules/eshop-checkout/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|modules|eshop-featured-products|components|curated-product-list'] = {
                c: () => require('partner/modules/eshop-featured-products/components/curated-product-list.component.tsx'),
                cn: '__local__-__local__-curated-product-list'
            };
componentDictionary['__local__|__local__|modules|eshop-header|components|cart-icon'] = {
                c: () => require('partner/modules/eshop-header/components/cart-icon.component.tsx'),
                cn: '__local__-__local__-cart-icon'
            };
componentDictionary['__local__|__local__|modules|eshop-latest-products|components|curated-product-list'] = {
                c: () => require('partner/modules/eshop-latest-products/components/curated-product-list.component.tsx'),
                cn: '__local__-__local__-curated-product-list'
            };
componentDictionary['__local__|__local__|modules|lianxin-checkout|components|cartlineitem'] = {
                c: () => require('partner/modules/lianxin-checkout/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|modules|product-list|component|btrts-add-to-cart-source'] = {
                c: () => require('partner/modules/product-list/component/btrts-add-to-cart-source.component.tsx'),
                cn: '__local__-__local__-btrts-add-to-cart-source'
            };
componentDictionary['__local__|__local__|modules|product-list|component|btrts-add-to-cart'] = {
                c: () => require('partner/modules/product-list/component/btrts-add-to-cart.component.tsx'),
                cn: '__local__-__local__-btrts-add-to-cart'
            };
componentDictionary['__local__|__local__|modules|product-list|component|btrts-product-list'] = {
                c: () => require('partner/modules/product-list/component/btrts-product-list.component.tsx'),
                cn: '__local__-__local__-btrts-product-list'
            };
componentDictionary['__local__|__local__|modules|product-list|component|donations-product-list'] = {
                c: () => require('partner/modules/product-list/component/donations-product-list.component.tsx'),
                cn: '__local__-__local__-donations-product-list'
            };
componentDictionary['__local__|__local__|themes|btrts-kiosk|views|components|cartlineitem'] = {
                c: () => require('partner/themes/btrts-kiosk/views/components/cartlineitem.component.tsx'),
                cn: '__local__-__local__-cartlineitem'
            };
componentDictionary['__local__|__local__|themes|btrts-kiosk|views|components|promocode'] = {
                c: () => require('partner/themes/btrts-kiosk/views/components/promocode.component.tsx'),
                cn: '__local__-__local__-promocode'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cartlineitem'
            };
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
                c: () => require('@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
                cn: '@msdyn365-commerce-modules-fabrikam-design-kit-promocode'
            };